export const GLOBAL_STATE = 'CourseCampaign'

export const COURSE_CAMPAIGN = 'courseCampaign'
export const COURSE_CAMPAIGN_CREATE = 'courseCampaignCreate'
export const COURSE_CAMPAIGN_LIST = 'courseCampaignList'
export const COURSE_CAMPAIGN_ALL = 'courseCampaignAll'
